
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteM as ObiOwnShipRemoteMElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-m.js';
 
 
 

 
 export const ObiOwnShipRemoteM = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-m',
   elementClass: ObiOwnShipRemoteMElement,
   events: {
     
   }
  });
 
 